import uniq from 'lodash.uniq';
// Makes a few changes to the w4 data to conform to the DocumentSigner API:
// 1. Convert field options from ['foo', 'bar', 'baz']
// to { foo: 'foo', bar: 'bar', baz: 'baz' }.
// 2. Give radio group items the fieldType RDO.
// 3. Add radioGroupPages attribute to radio fields.
// 4. Ensure every rule's conditionalRuleIds field always contains an array.
export default data => {
  if (!data) return null;

  return {
    ...data,
    fields: data.fields.map(field => ({
      ...field,
      options:
        field.options &&
        field.options.reduce((optionsObj, option) => {
          optionsObj[option] = option;
          return optionsObj;
        }, {}),
      radioGroupItems:
        field.radioGroupItems &&
        field.radioGroupItems.map(radioGroupItem => ({
          ...radioGroupItem,
          fieldType: 'RDO',
        })),
      radioGroupPages:
        field.radioGroupItems &&
        uniq(field.radioGroupItems.map(({ page }) => page)),
    })),
    rules: data.rules.map(rule => ({
      ...rule,
      conditionalRuleIds: rule.conditionalRuleIds || [],
    })),
  };
};
